import { Link } from "react-router-dom";
import LegalPageLayout from "@/components/LegalPageLayout";
import {
  COMPANY_ADDRESS_FULL,
  COMPANY_BRAND_NAME,
  COMPANY_CIF,
  COMPANY_CONTACT_EMAIL,
  COMPANY_LEGAL_NAME,
} from "@/lib/company";

const PoliticaPrivacidad = () => {
  return (
    <LegalPageLayout title="Política de Privacidad">
            <p className="text-gray-600 mb-6">
              Última actualización: {new Date().toLocaleDateString("es-ES")}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Información del Responsable</h2>
              <p className="text-gray-700 mb-4">
                <strong>Razón social:</strong> {COMPANY_LEGAL_NAME}<br />
                <strong>Marca comercial:</strong> {COMPANY_BRAND_NAME}<br />
                <strong>Responsable del tratamiento:</strong> {COMPANY_LEGAL_NAME}<br />
                <strong>Domicilio social y fiscal:</strong> {COMPANY_ADDRESS_FULL}<br />
                <strong>Email:</strong>{" "}
                <a href={`mailto:${COMPANY_CONTACT_EMAIL}`} className="text-taxby-purple hover:text-taxby-violet hover:underline">
                  {COMPANY_CONTACT_EMAIL}
                </a>
                <br />
                <strong>CIF:</strong> {COMPANY_CIF}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Datos que Recopilamos</h2>
              <p className="text-gray-700 mb-4">
                Recopilamos los siguientes tipos de información:
              </p>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.1 Datos de identificación personal</h3>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Nombre y apellidos</li>
                <li>Dirección de correo electrónico</li>
                <li>Número de teléfono</li>
                <li>NIF/CIF</li>
                <li>Dirección postal</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.2 Datos financieros y contables</h3>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Información de ingresos y gastos</li>
                <li>Datos de facturación</li>
                <li>Información bancaria (cuando sea necesario)</li>
                <li>Documentos fiscales</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.3 Datos de uso</h3>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Información de navegación</li>
                <li>Datos de sesión</li>
                <li>Preferencias de usuario</li>
                <li>Información técnica del dispositivo</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Finalidades del Tratamiento</h2>
              <p className="text-gray-700 mb-4">
                Utilizamos tus datos para las siguientes finalidades:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Prestar nuestros servicios de gestión fiscal y contable</li>
                <li>Gestionar tu cuenta de usuario</li>
                <li>Procesar pagos y facturación</li>
                <li>Enviar comunicaciones relacionadas con el servicio</li>
                <li>Mejorar nuestros servicios y experiencia de usuario</li>
                <li>Cumplir con obligaciones legales y fiscales</li>
                <li>Prevenir fraudes y garantizar la seguridad</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Base Legal</h2>
              <p className="text-gray-700 mb-4">
                El tratamiento de tus datos se basa en:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>Consentimiento:</strong> Para el envío de comunicaciones comerciales</li>
                <li><strong>Ejecución del contrato:</strong> Para la prestación de nuestros servicios</li>
                <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios y prevenir fraudes</li>
                <li><strong>Cumplimiento legal:</strong> Para cumplir con obligaciones fiscales y contables</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Destinatarios de los Datos</h2>
              <p className="text-gray-700 mb-4">
                Tus datos pueden ser comunicados a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Administración Tributaria (Agencia Tributaria)</li>
                <li>Proveedores de servicios tecnológicos</li>
                <li>Proveedores de servicios de pago</li>
                <li>Autoridades competentes cuando sea legalmente requerido</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Conservación de Datos</h2>
              <p className="text-gray-700 mb-4">
                Conservamos tus datos durante el tiempo necesario para cumplir con las finalidades descritas, 
                especialmente para cumplir con las obligaciones legales, contables y fiscales. En general:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Datos de la cuenta: Mientras mantengas una cuenta activa</li>
                <li>Datos contables y fiscales: 6 años (obligación legal)</li>
                <li>Datos de facturación: 5 años (obligación legal)</li>
                <li>Datos de navegación: 2 años</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Tus Derechos</h2>
              <p className="text-gray-700 mb-4">
                Como titular de los datos, tienes los siguientes derechos:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>Acceso:</strong> Conocer qué datos tuyos tratamos</li>
                <li><strong>Rectificación:</strong> Corregir datos inexactos</li>
                <li><strong>Supresión:</strong> Eliminar tus datos cuando sea posible</li>
                <li><strong>Limitación:</strong> Limitar el tratamiento en ciertos casos</li>
                <li><strong>Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
                <li><strong>Oposición:</strong> Oponerte al tratamiento basado en interés legítimo</li>
                <li><strong>Retirada del consentimiento:</strong> Revocar el consentimiento otorgado</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Ejercicio de Derechos</h2>
              <p className="text-gray-700 mb-4">
                Puedes ejercer tus derechos enviando un email a{" "}
                <a href={`mailto:${COMPANY_CONTACT_EMAIL}`} className="text-taxby-purple hover:text-taxby-violet hover:underline">
                  {COMPANY_CONTACT_EMAIL}
                </a>{" "}
                o escribiendo a nuestra dirección postal ({COMPANY_ADDRESS_FULL}). 
                Incluye en tu solicitud:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Tu nombre y apellidos</li>
                <li>Tu dirección de correo electrónico</li>
                <li>El derecho que deseas ejercer</li>
                <li>Motivo de la solicitud (si aplica)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Seguridad</h2>
              <p className="text-gray-700 mb-4">
                Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos personales 
                contra el acceso no autorizado, alteración, divulgación o destrucción. Estas medidas incluyen:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Encriptación de datos en tránsito y en reposo</li>
                <li>Acceso restringido a datos personales</li>
                <li>Monitoreo regular de sistemas</li>
                <li>Copias de seguridad seguras</li>
                <li>Formación del personal en seguridad</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Cookies</h2>
              <p className="text-gray-700 mb-4">
                Utilizamos cookies y tecnologías similares. Para más información, consulta nuestra 
                <Link to="/politica-cookies" className="text-taxby-purple hover:underline ml-1">
                  Política de Cookies
                </Link>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Transferencias Internacionales</h2>
              <p className="text-gray-700 mb-4">
                Algunos de nuestros proveedores pueden estar ubicados fuera del Espacio Económico Europeo. 
                En estos casos, garantizamos que se aplican las medidas de protección adecuadas.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Modificaciones</h2>
              <p className="text-gray-700 mb-4">
                Nos reservamos el derecho de modificar esta política de privacidad. Los cambios se publicarán 
                en esta página con la fecha de última actualización.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Inicio de sesión con Google (Google OAuth)</h2>
              <p className="text-gray-700 mb-4">
                TaxBy permite iniciar sesión mediante tu cuenta de Google. En este caso, accedemos únicamente a tu
                dirección de correo electrónico y a la información básica de tu perfil (nombre) con el fin exclusivo
                de crear y autenticar tu cuenta en TaxBy.
              </p>
              <p className="text-gray-700 mb-4">
                El uso de la información recibida de las APIs de Google se ajusta a la{" "}
                <a
                  href="https://developers.google.com/terms/api-services-user-data-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-taxby-purple hover:text-taxby-violet hover:underline"
                >
                  Política de Datos de Usuario de los Servicios de la API de Google
                </a>
                , incluidos sus requisitos de Uso Limitado (<em>Limited Use</em>). En particular:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Solo accedemos a los datos de Google necesarios para autenticar tu cuenta (correo y nombre).</li>
                <li>No utilizamos estos datos con fines publicitarios ni de seguimiento.</li>
                <li>No cedemos, vendemos ni transferimos a terceros la información obtenida de las APIs de Google, salvo cuando sea necesario para prestar el servicio (por ejemplo, proveedores de infraestructura bajo contrato de confidencialidad).</li>
                <li>No permitimos que seres humanos lean los datos de usuario de Google salvo cuando sea imprescindible por razones de seguridad, para cumplir la legislación aplicable o con tu consentimiento expreso.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">14. Autoridad de Control</h2>
              <p className="text-gray-700 mb-4">
                Si consideras que el tratamiento de tus datos no se ajusta a la normativa vigente, 
                puedes presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">15. Contacto</h2>
              <p className="text-gray-700 mb-4">
                Para cualquier consulta sobre esta política de privacidad, puedes contactarnos en:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>
                  Email:{" "}
                  <a href={`mailto:${COMPANY_CONTACT_EMAIL}`} className="text-taxby-purple hover:text-taxby-violet hover:underline">
                    {COMPANY_CONTACT_EMAIL}
                  </a>
                </li>
                <li>Dirección: {COMPANY_ADDRESS_FULL}</li>
                <li>CIF: {COMPANY_CIF}</li>
              </ul>
            </section>
    </LegalPageLayout>
  );
};

export default PoliticaPrivacidad; 